import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, EventType, AuthenticationResult } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { setMsalInstance } from "./utils/authFetch";
import { bootstrapSandboxFromUrl, sandboxRole } from "./utils/sandboxSession";
import App from "./App";

// Sandbox-Zugang aus dem GA-Portal: Das Token-Paket steht im URL-Fragment und
// muss übernommen (und aus der Adresszeile entfernt) sein, bevor irgendetwas
// rendert – sonst fragt die erste API-Anfrage noch nach einem Microsoft-Token.
if (bootstrapSandboxFromUrl()) {
  const role = sandboxRole();
  // Einstiegsadresse ist /sandbox; von dort geht es auf die Startseite der
  // jeweiligen Rolle, damit ein Administrator nicht erst im Mitarbeiterbereich landet.
  if (window.location.pathname.replace(/\/+$/, "") === "/sandbox") {
    window.history.replaceState(null, "", role === "admin" ? "/admin" : "/dashboard");
  }
}

const msalInstance = new PublicClientApplication(msalConfig);
setMsalInstance(msalInstance);

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  }
});

// initialize() muss vor dem Render awaited werden (MSAL v3)
// MsalProvider ruft handleRedirectPromise() intern – nicht nochmal manuell aufrufen
msalInstance.initialize().then(() => {
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
